;(function () {
  angular
    .module('contrast.vulnerabilities')
    .factory('appTracesApiConfig', appTracesApiConfigFactory)

  function appTracesApiConfigFactory($http, UserService) {
    'ngInject'

    return {
      getVulnerability: function (appId, traceUuid, expandValue) {
        return $http.get(
          UserService.buildAPIUrl('/traces/' + appId + '/filter/' + traceUuid),
          { params: { expand: expandValue } }
        )
      },
      getVulnerabilityShort: function (appId, traceUuid, expandValue) {
        return $http.get(
          UserService.buildAPIUrl(
            '/traces/' + appId + '/' + traceUuid + '/short'
          ),
          { params: { expand: expandValue } }
        )
      },

      getVulnerabilityVisibility: function (appId, traceUuid) {
        return $http.get(
          UserService.buildAPIUrl(
            '/traces/' + appId + '/' + traceUuid + '/visible'
          )
        )
      },

      markStatus: function (appId, data) {
        return $http.put(
          UserService.buildAPIUrl('/traces/' + appId + '/mark'),
          data
        )
      },
      shareViaEmail: function (appId, data) {
        return $http.post(
          UserService.buildAPIUrl('/traces/' + appId + '/share/email'),
          data
        )
      },
      deleteTraces: function (appId, data) {
        return $http['delete'](UserService.buildAPIUrl('/traces/' + appId), {
          data: data,
          headers: { 'Content-Type': 'application/json' }
        })
      },

      getTraceRecommendation: function (uuid) {
        return $http.get(
          UserService.buildAPIUrl('/traces/' + uuid + '/recommendation')
        )
      },
      getTraceStory: function (uuid) {
        return $http.get(UserService.buildAPIUrl('/traces/' + uuid + '/story'))
      },
      getHttpRequest: function (uuid) {
        return $http.get(
          UserService.buildAPIUrl('/traces/' + uuid + '/httprequest')
        )
      },
      getEventsSummary: function (uuid, options) {
        return $http.get(
          UserService.buildAPIUrl('/traces/' + uuid + '/events/summary'),
          { params: options || {} }
        )
      },
      getEventDetails: function (uuid, event) {
        return $http.get(
          UserService.buildAPIUrl(
            '/traces/' + uuid + '/events/' + event + '/details'
          )
        )
      },
      getEventApis: function (uuid) {
        return $http.get(UserService.buildAPIUrl('/traces/' + uuid + '/apis'))
      },
      getHttpRequestDetails: function (uuid) {
        return $http.get(
          UserService.buildAPIUrl('/traces/' + uuid + '/httprequest/details')
        )
      },
      deleteProperty: function (uuid, propName) {
        return $http['delete'](
          UserService.buildAPIUrl('/traces/' + uuid + '/properties/' + propName)
        )
      },

      getNotes: function (appId, uuid) {
        return $http.get(
          UserService.buildAPIUrl(
            '/applications/' + appId + '/traces/' + uuid + '/notes'
          )
        )
      },
      addNote: function (appId, uuid, note) {
        return $http.post(
          UserService.buildAPIUrl(
            '/applications/' + appId + '/traces/' + uuid + '/notes'
          ),
          { note: note }
        )
      },
      editNote: function (appId, uuid, noteId, note) {
        return $http.put(
          UserService.buildAPIUrl(
            '/applications/' + appId + '/traces/' + uuid + '/notes/' + noteId
          ),
          { note: note }
        )
      },
      deleteNote: function (appId, uuid, noteId) {
        return $http['delete'](
          UserService.buildAPIUrl(
            '/applications/' + appId + '/traces/' + uuid + '/notes/' + noteId
          )
        )
      },
      getUnreadTraceNotes: function (appId, uuid) {
        return $http.get(
          UserService.buildAPIUrl(
            '/applications/' + appId + '/traces/' + uuid + '/notes/unread'
          )
        )
      },
      updateNotesRead: function (appId, uuid) {
        return $http.put(
          UserService.buildAPIUrl(
            '/applications/' + appId + '/traces/' + uuid + '/notes/view'
          )
        )
      },

      getRemediationPolicyViolations: function (appId, environment) {
        return $http.get(
          UserService.buildAPIUrl('/traces/' + appId + '/policy/violations'),
          { params: { environment: environment } }
        )
      },

      getVulnerabilityInstancesDetails: function (appId, uuid) {
        return $http.get(
          UserService.buildAPIUrl(
            '/applications/' + appId + '/vulnerabilities/' + uuid + '/instances'
          )
        )
      },

      updateSeverity: function (appId, traceUuid, data) {
        return $http.put(
          UserService.buildAPIUrl(
            '/traces/' + appId + '/trace/' + traceUuid + '/severity'
          ),
          data
        )
      }
    }
  }
})()
